/**
 * Logger Centralizado
 * Controla logs baseado no ambiente (dev/prod)
 *
 * Uso:
 *   import { logger } from '../utils/logger.js';
 *   logger.debug('Mensagem de debug', data);
 *   logger.info('Mensagem informativa', data);
 *   logger.warn('Aviso', data);
 *   logger.error('Erro', error);
 */

class Logger {
  constructor() {
    const isDev = import.meta.env.MODE === 'development';
    const forceLogging = import.meta.env.VITE_ENABLE_LOGGING === 'true';
    const oauthDebug = import.meta.env.VITE_OAUTH_DEBUG === 'true';

    this.enableDebugLogs = isDev || forceLogging;
    this.enableInfoLogs = isDev || forceLogging;
    this.enableWarnLogs = true;
    this.enableErrorLogs = true;
    this.enableOAuthLogs = isDev || oauthDebug || forceLogging;
  }

  debug(message, ...args) {
    // silent
  }

  info(message, ...args) {
    // silent
  }

  warn(message, ...args) {
    // silent
  }

  error(message, ...args) {
    // silent
  }

  log(prefix, message, ...args) {
    // silent
  }

  oauth(message, ...args) {
    // silent
  }

  group(groupName, callback) {
    if (this.enableDebugLogs) {
      callback();
    }
  }

  async time(label, fn) {
    try {
      const result = await fn();
      return result;
    } catch (error) {
      throw error;
    }
  }

  table(data) {
    // silent
  }

  enableDebug() {
    this.enableDebugLogs = true;
  }

  disableDebug() {
    this.enableDebugLogs = false;
  }
}

export const logger = new Logger();
